import React, { useState, useEffect } from 'react';

const AddTopic = () => {
    const [subjects, setSubjects] = useState([]);
    const [subjectname, setSubjectName] = useState('');
    const [topics, setTopics] = useState([]);

    const [title, setTitle] = useState('');
    const [topic_url, setTopicUrl] = useState('');
    const [content, setContent] = useState('');

    // Modal states
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editTopic, setEditTopic] = useState(null);

    /* -------- LOAD SUBJECTS -------- */
    useEffect(() => {
        const fetchSubjects = async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/api/course/subject`, {
                    headers: {
                        "Authorization": "Bearer " + localStorage.getItem("token")
                    }
                });
                const data = await res.json();
                setSubjects(data);
            } catch (err) {
                console.error("Failed to fetch subjects:", err);
            }
        };
        fetchSubjects();
    }, []);

    /* -------- LOAD TOPICS -------- */
    const loadTopics = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/course/topic`, {
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token")
                }
            });
            const data = await res.json();
            setTopics(data);
        } catch (err) {
            console.error("Failed to fetch topics:", err);
        }
    };

    useEffect(() => {
        loadTopics();
    }, []);

    /* -------- ADD TOPIC -------- */
    const handleAddTopic = async (e) => {
        e.preventDefault();

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/course/topic`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify({ subjectname, title, topic_url, content })
            });

            if (res.ok) {
                alert("Topic Added Successfully");
                setTitle('');
                setTopicUrl('');
                setContent('');
                setSubjectName('');
                loadTopics();
            } else {
                const err = await res.json();
                alert(err.error);
            }
        } catch (err) {
            console.error("Error adding topic:", err);
        }
    };

    /* -------- DELETE TOPIC -------- */
    const deleteTopic = async (id) => {
        if (!window.confirm("Are you sure you want to delete this topic?")) return;

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/course/topic/${id}`, {
                method: "DELETE",
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token")
                }
            });

            if (res.ok) {
                alert("Topic Deleted");
                loadTopics();
            } else {
                const err = await res.json();
                alert(err.error);
            }

        } catch (err) {
            console.error("Delete error:", err);
        }
    };

    /* -------- UPDATE TOPIC (PUT) -------- */
    const updateTopic = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/course/topic/${editTopic.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify({
                    subjectname: editTopic.subjectname,
                    title: editTopic.title,
                    topic_url: editTopic.topic_url,
                    content: editTopic.content
                })
            });

            if (res.ok) {
                alert("Topic Updated Successfully");
                setIsModalOpen(false);
                loadTopics();
            } else {
                const err = await res.json();
                alert(err.error);
            }
        } catch (error) {
            console.error("Update error:", error);
        }
    };

    return (
        <div className="container mt-5">
            <h2>Add Topic</h2>

            {/* ---------------- ADD TOPIC FORM ---------------- */}
            <form onSubmit={handleAddTopic}>
                <select value={subjectname} onChange={(e) => setSubjectName(e.target.value)}>
                    <option value="">Select Subject</option>
                    {subjects.map(s => (
                        <option key={s.id} value={s.subjectname}>
                            {s.subjectname}
                        </option>
                    ))}
                </select>

                <input type="text" value={title} placeholder="Title"
                    onChange={(e) => setTitle(e.target.value)} />

                <input type="text" value={topic_url} placeholder="Topic URL"
                    onChange={(e) => setTopicUrl(e.target.value)} />

                <textarea value={content} placeholder="Content"
                    onChange={(e) => setContent(e.target.value)} />

                <button type="submit">Add Topic</button>
            </form>

            {/* ---------------- TOPIC LIST ---------------- */}
            <h3 className="mt-4">Topics:</h3>

            {topics.map(topic => (
                <div key={topic.id} style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "10px" }}>
                    <p style={{ margin: 0 }}>
                        {topic.subjectname} — {topic.title} — {topic.topic_url}
                    </p>

                    <button
                        onClick={() => {
                            setEditTopic(topic);
                            setIsModalOpen(true);
                        }}
                    >
                        Edit
                    </button>

                    <button onClick={() => deleteTopic(topic.id)}>Delete</button>
                </div>
            ))}

            {/* ---------------- EDIT MODAL ---------------- */}
            {isModalOpen && (
                <div style={modalOverlay}>
                    <div style={modalBox}>
                        <h3>Edit Topic</h3>

                        <select
                            value={editTopic.subjectname}
                            onChange={(e) => setEditTopic({ ...editTopic, subjectname: e.target.value })}
                        >
                            {subjects.map((s) => (
                                <option key={s.id} value={s.subjectname}>
                                    {s.subjectname}
                                </option>
                            ))}
                        </select>

                        <input
                            type="text"
                            value={editTopic.title}
                            onChange={(e) => setEditTopic({ ...editTopic, title: e.target.value })}
                        />

                        <input
                            type="text"
                            value={editTopic.topic_url}
                            onChange={(e) => setEditTopic({ ...editTopic, topic_url: e.target.value })}
                        />

                        <textarea
                            value={editTopic.content}
                            onChange={(e) => setEditTopic({ ...editTopic, content: e.target.value })}
                        />

                        <button onClick={updateTopic}>Save Changes</button>
                        <button onClick={() => setIsModalOpen(false)}>Cancel</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddTopic;


/* -------- MODAL STYLES -------- */
const modalOverlay = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
};

const modalBox = {
    background: "white",
    padding: "20px",
    borderRadius: "8px",
    width: "400px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
};
